"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[70515],{

/***/ 22601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useFormControl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _FormControlContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15736);


function useFormControl() {
  return react__WEBPACK_IMPORTED_MODULE_0__.useContext(_FormControlContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
}

/***/ }),

/***/ 9570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81225);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44168);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86338);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52543);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59693);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93871);
/* harmony import */ var _internal_SwitchBase__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28113);


// @inheritedComponent IconButton








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      width: 34 + 12 * 2,
      height: 14 + 12 * 2,
      overflow: 'hidden',
      padding: 12,
      boxSizing: 'border-box',
      position: 'relative',
      flexShrink: 0,
      zIndex: 0,
      // Reset the stacking context.
      verticalAlign: 'middle',
      // For correct alignment with the text.
      '@media print': {
        colorAdjust: 'exact'
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -8
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -8
    },

    /* Styles applied to the internal `SwitchBase` component's `root` class. */
    switchBase: {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1,
      // Render above the focus ripple.
      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
      transition: theme.transitions.create(['left', 'transform'], {
        duration: theme.transitions.duration.shortest
      }),
      '&$checked': {
        transform: 'translateX(20px)'
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        opacity: 0.5
      },
      '&$disabled + $track': {
        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.primary.main
      },
      '&$disabled + $track': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.secondary.main
      },
      '&$disabled + $track': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      width: 40,
      height: 24,
      padding: 7,
      '& $thumb': {
        width: 16,
        height: 16
      },
      '& $switchBase': {
        padding: 4,
        '&$checked': {
          transform: 'translateX(16px)'
        }
      }
    },

    /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */
    checked: {},

    /* Pseudo-class applied to the internal SwitchBase component's disabled class. */
    disabled: {},

    /* Styles applied to the internal SwitchBase component's input element. */
    input: {
      left: '-100%',
      width: '300%'
    },

    /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */
    thumb: {
      boxShadow: theme.shadows[1],
      backgroundColor: 'currentColor',
      width: 20,
      height: 20,
      borderRadius: '50%'
    },

    /* Styles applied to the track element. */
    track: {
      height: '100%',
      width: '100%',
      borderRadius: 14 / 2,
      zIndex: -1,
      transition: theme.transitions.create(['opacity', 'background-color'], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
    }
  };
};
var Switch = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Switch(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, ["classes", "className", "color", "edge", "size"]);

  var icon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classes.thumb
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__["default"])(classes.root, className, {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge], size === "small" && classes["size".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(size))])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_SwitchBase__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    type: "checkbox",
    icon: icon,
    checkedIcon: icon,
    classes: {
      root: (0,clsx__WEBPACK_IMPORTED_MODULE_4__["default"])(classes.switchBase, classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(color))]),
      input: classes.input,
      checked: classes.checked,
      disabled: classes.disabled
    },
    ref: ref
  }, other)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classes.track
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(styles, {
  name: 'MuiSwitch'
})(Switch));

/***/ }),

/***/ 28113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81225);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83488);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44168);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86338);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86010);
/* harmony import */ var _utils_useControlled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22775);
/* harmony import */ var _FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22601);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52543);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17812);











var styles = {
  root: {
    padding: 9
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
  }
};
/**
 * @ignore - internal component.
 */

var SwitchBase = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function SwitchBase(props, ref) {
  var autoFocus = props.autoFocus,
      checkedProp = props.checked,
      checkedIcon = props.checkedIcon,
      classes = props.classes,
      className = props.className,
      defaultChecked = props.defaultChecked,
      disabledProp = props.disabled,
      icon = props.icon,
      id = props.id,
      inputProps = props.inputProps,
      inputRef = props.inputRef,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      readOnly = props.readOnly,
      required = props.required,
      tabIndex = props.tabIndex,
      type = props.type,
      value = props.value,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);

  var _useControlled = (0,_utils_useControlled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  }),
      _useControlled2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useControlled, 2),
      checked = _useControlled2[0],
      setCheckedState = _useControlled2[1];

  var muiFormControl = (0,_FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();

  var handleFocus = function handleFocus(event) {
    if (onFocus) {
      onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };

  var handleInputChange = function handleInputChange(event) {
    var newChecked = event.target.checked;
    setCheckedState(newChecked);

    if (onChange) {
      // TODO v5: remove the second argument.
      onChange(event, newChecked);
    }
  };

  var disabled = disabledProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var hasLabelFor = type === 'checkbox' || type === 'radio';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    component: "span",
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__["default"])(classes.root, className, checked && classes.checked, disabled && classes.disabled),
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    autoFocus: autoFocus,
    checked: checkedProp,
    defaultChecked: defaultChecked,
    className: classes.input,
    disabled: disabled,
    id: hasLabelFor && id,
    name: name,
    onChange: handleInputChange,
    readOnly: readOnly,
    ref: inputRef,
    required: required,
    tabIndex: tabIndex,
    type: type,
    value: value
  }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.

 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(styles, {
  name: 'PrivateSwitchBase'
})(SwitchBase));

/***/ }),

/***/ 86699:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value: true}));var _chunkOZRWBVXCjs = __webpack_require__(30004);var _react = __webpack_require__(67294);var o=_react.createContext.call(void 0, _chunkOZRWBVXCjs.a),a= exports.a =o,x= exports.b =()=>_react.useContext.call(void 0, o);exports.a = a; exports.b = x;


/***/ }),

/***/ 41798:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value: true})); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunk52DAEPPLjs = __webpack_require__(86699);var _react = __webpack_require__(70917);var _styled = __webpack_require__(95934); var _styled2 = _interopRequireDefault(_styled);var _react3 = __webpack_require__(67294);var _jsxruntime = __webpack_require__(85893);var $=_react.css`
  .highlighter {
    opacity: 1;
  }
`,v=(e,t)=>e?t.palette.BASE_FILL:t.palette.SECONDARY,A=_styled2.default.a`
  min-height: ${e=>e.theme.measurements.spacing(24)};
  height: 100%;
  line-height: ${e=>e.theme.measurements.spacing(10)};
  font-size: ${e=>e.theme.measurements.spacing(7)};
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${e=>e.theme.measurements.spacing(2)};
  flex-direction: row;
  min-width: fit-content;
  width: auto;
  color: ${e=>v(e.$isActive,e.theme)};
  cursor: ${e=>e.$disabled?"not-allowed":"pointer"};
  pointer-events: ${e=>e.$disabled?"none":"auto"};
  position: relative;

  &:hover {
    color: ${e=>e.theme.palette.BASE_FILL};
  }

  ${e=>e.$isActive?$:""}
`,T=_styled2.default.span`
  height: ${e=>e.theme.measurements.spacing(1)};
  background: ${e=>e.theme.palette.BASE_FILL};
  border-top-right-radius: ${e=>e.theme.measurements.shape(2)};
  border-top-left-radius: ${e=>e.theme.measurements.shape(2)};
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
`,S=_react3.forwardRef.call(void 0, (e,t)=>{let{children:l,index:i,isActive:c,title:d,tabLabel:s,disabled:h,className:m}=e,n=_chunk52DAEPPLjs.b.call(void 0, ).tabsInfo.selectedTabIndex===i||c,o=_chunk52DAEPPLjs.b.call(void 0, ).setActiveTab,b=_react3.useCallback.call(void 0, g=>{g.preventDefault(),o(i||0,e)},[i,o]);return _jsxruntime.jsxs.call(void 0, A,{$isActive:n||!1,$disabled:h,title:d||s,href:"#",onClick:b,className:`${m||""} aquilla-tab tab ${n?"activetab":""}`,ref:t,children:[s||l,_jsxruntime.jsx.call(void 0, T,{className:"highlighter"})]})}),I= exports.a =S;exports.a = I;


/***/ }),

/***/ 30004:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value: true}));var t={tabsInfo:{selectedTabIndex:0},preLoadTabs:!1,setActiveTab:(e,a)=>({index:e,selectedTabProps:a})},s= exports.a =t;exports.a = s;


/***/ }),

/***/ 93951:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value: true})); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkFU6IGQCVjs = __webpack_require__(41798);var _chunk52DAEPPLjs = __webpack_require__(86699);var _react = __webpack_require__(67294); var _react2 = _interopRequireDefault(_react);var _styled = __webpack_require__(95934); var _styled2 = _interopRequireDefault(_styled);var _jsxruntime = __webpack_require__(85893);var u=_styled2.default.div`
  min-height: ${t=>t.theme.measurements.spacing(24)};
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  text-align: left;
  gap: ${t=>t.theme.measurements.spacing(12)};

  &::-webkit-scrollbar {
    display: none;
  }
`;function d({children:t,className:i}){let a=_react.useRef.call(void 0, null),l=_react2.default.Children.map(t,(e,n)=>e.type===_chunkFU6IGQCVjs.a?_react2.default.cloneElement(e,{index:n}):e),c=_chunk52DAEPPLjs.b.call(void 0, ).tabsInfo.selectedTabIndex;return _react.useEffect.call(void 0, ()=>{let e=a.current;if(e){let n=e.querySelector(".activetab");n&&(e.scrollLeft=n.offsetLeft-20)}},[c]),_jsxruntime.jsx.call(void 0, u,{ref:a,className:`${i||""} aquilla-tablist tablist`,children:l})}var v=d;exports.a = v;


/***/ }),

/***/ 65674:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value: true})); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkXM7MS2LCjs = __webpack_require__(77561);var _styled = __webpack_require__(95934); var _styled2 = _interopRequireDefault(_styled);var _react = __webpack_require__(67294); var _react2 = _interopRequireDefault(_react);var _jsxruntime = __webpack_require__(85893);var m=_styled2.default.div`
  margin-top: ${e=>e.theme.measurements.spacing(5)};
`;function c({children:e,className:r}){let s=_react2.default.Children.map(e,(a,l)=>a.type===_chunkXM7MS2LCjs.a?_react2.default.cloneElement(a,{index:l}):a);return _jsxruntime.jsx.call(void 0, m,{className:`${r||""} aquilla-tabpanels tabpanels`,children:s})}var u=c;exports.a = u;


/***/ }),

/***/ 59354:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value: true})); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunk52DAEPPLjs = __webpack_require__(86699);var _chunkOZRWBVXCjs = __webpack_require__(30004);var _chunk262UWVGVjs = __webpack_require__(37186);var _styled = __webpack_require__(95934); var _styled2 = _interopRequireDefault(_styled);var _react = __webpack_require__(67294); var _react2 = _interopRequireDefault(_react);var _jsxruntime = __webpack_require__(85893);var g=_styled2.default.div`
  display: flex;
  flex-flow: column;
`;function y({children:m,className:T,preLoadTabs:r=!1,index:e,onChange:t,ariaLabel:I,title:d}){let[n,p]=_react2.default.useState(_chunk262UWVGVjs.b.call(void 0, _chunk262UWVGVjs.a.call(void 0, {},_chunkOZRWBVXCjs.a.tabsInfo),{selectedTabIndex:e||0})),o=(l,b)=>(t||Number.isInteger(e)?t&&t(l,b):p(x=>_chunk262UWVGVjs.b.call(void 0, _chunk262UWVGVjs.a.call(void 0, {},x),{selectedTabIndex:l})),{index:l,selectedTabProps:b}),v=_react2.default.useMemo(()=>t||Number.isInteger(e)?{tabsInfo:_chunk262UWVGVjs.b.call(void 0, _chunk262UWVGVjs.a.call(void 0, {},n),{selectedTabIndex:e||0}),setActiveTab:o,preLoadTabs:r}:{tabsInfo:n,setActiveTab:o,preLoadTabs:r},[n,o,r,e]);return _jsxruntime.jsx.call(void 0, g,{title:d,"aria-label":I,className:`${T||""} aquilla-tabs tabs`,children:_jsxruntime.jsx.call(void 0, _chunk52DAEPPLjs.a.Provider,{value:v,children:m})})}var w=y;exports.a = w;


/***/ }),

/***/ 77561:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value: true})); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunk52DAEPPLjs = __webpack_require__(86699);var _styled = __webpack_require__(95934); var _styled2 = _interopRequireDefault(_styled);var _jsxruntime = __webpack_require__(85893);var i=_styled2.default.div`
  ${e=>e.$isActive?"display: block;":"display: none;"}
  color: ${e=>e.theme.palette.BASE_FILL};
`;function r({children:e,className:o,index:t}){let n=_chunk52DAEPPLjs.b.call(void 0, ).tabsInfo.selectedTabIndex,{preLoadTabs:l}=_chunk52DAEPPLjs.b.call(void 0, );return _jsxruntime.jsx.call(void 0, i,{className:`${o||""} aquilla-tabpanel tabpanel`,$isActive:t===n,children:t===n||l?e:""})}var d=r;exports.a = d;


/***/ }),

/***/ 77268:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
__webpack_unused_export__ = ({value: true});var _chunkUEXDW63Vjs = __webpack_require__(93951);var _chunkFU6IGQCVjs = __webpack_require__(41798);var _chunkVJTXG2DRjs = __webpack_require__(65674);var _chunkXM7MS2LCjs = __webpack_require__(77561);var _chunkXJTN4UM7js = __webpack_require__(59354);var _chunk52DAEPPLjs = __webpack_require__(86699);__webpack_require__(30004);__webpack_require__(37186);exports.OK = _chunkFU6IGQCVjs.a; exports.td = _chunkUEXDW63Vjs.a; exports.x4 = _chunkXM7MS2LCjs.a; exports.nP = _chunkVJTXG2DRjs.a; exports.mQ = _chunkXJTN4UM7js.a; __webpack_unused_export__ = _chunk52DAEPPLjs.a; __webpack_unused_export__ = _chunk52DAEPPLjs.b;


/***/ }),

/***/ 8622:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
__webpack_unused_export__ = ({value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }var _chunkXC6L7SUYjs = __webpack_require__(44759);__webpack_require__(42310);__webpack_require__(37186);var _react = __webpack_require__(67294); var o = _interopRequireWildcard(_react);var _jsxruntime = __webpack_require__(85893);var i=o.forwardRef((l,c)=>{let{className:r,color:a,height:h=24,width:f=24}=l;return _jsxruntime.jsxs.call(void 0, _chunkXC6L7SUYjs.b,{className:r,ref:c,width:f,height:h,color:a,viewBox:"0 0 24 24",children:[_jsxruntime.jsxs.call(void 0, "g",{"clip-path":"url(#clip0_378_74042)",children:[_jsxruntime.jsx.call(void 0, "circle",{cx:"12",cy:"12",r:"12",fill:"#FFAB6E"}),_jsxruntime.jsx.call(void 0, "path",{d:"M9.09867 10.1846C8.2274 10.1846 7.50221 9.44572 7.74156 8.60796C7.98113 7.76941 8.39297 7.08803 8.9771 6.56383C9.77632 5.85461 10.8304 5.5 12.1393 5.5C13.5292 5.5 14.6354 5.9106 15.4578 6.7318C16.1528 7.45346 16.5003 8.36176 16.5003 9.45669C16.5003 10.2032 16.3381 10.8067 16.0138 11.2671C15.701 11.7274 15.064 12.2625 14.1026 12.8721C13.6856 13.1459 13.4192 13.5005 13.3034 13.936C13.1903 14.3813 12.8681 14.7572 12.4086 14.7572H11.442C10.9087 14.7572 10.4791 14.3198 10.4887 13.7866C10.5003 13.0774 10.6856 12.4802 11.0447 11.9949C11.23 11.7461 11.6064 11.4226 12.174 11.0244C12.6373 10.6885 12.9385 10.421 13.0775 10.2219C13.2281 10.0104 13.3034 9.73664 13.3034 9.4007C13.3034 9.05231 13.1875 8.77235 12.9559 8.56083C12.7358 8.33687 12.4462 8.22489 12.0871 8.22489C11.5782 8.22489 11.1974 8.40798 10.9449 8.77416C10.4772 9.45251 9.92266 10.1846 9.09867 10.1846Z",fill:"white"}),_jsxruntime.jsx.call(void 0, "path",{d:"M12.8864 16.2954C12.62 16.0412 12.3014 15.9141 11.9308 15.9141C11.5486 15.9141 11.2242 16.0412 10.9578 16.2954C10.703 16.5385 10.5756 16.8369 10.5756 17.1905C10.5756 17.5551 10.703 17.8645 10.9578 18.1187C11.2242 18.3729 11.5486 18.5 11.9308 18.5C12.3014 18.5 12.62 18.3729 12.8864 18.1187C13.1528 17.8645 13.286 17.5551 13.286 17.1905C13.286 16.8369 13.1528 16.5385 12.8864 16.2954Z",fill:"white"})]}),_jsxruntime.jsx.call(void 0, "defs",{children:_jsxruntime.jsx.call(void 0, "clipPath",{id:"clip0_378_74042",children:_jsxruntime.jsx.call(void 0, "rect",{width:"24",height:"24",fill:"white"})})})]})});i.displayName="AskADoubt";var d=i;__webpack_unused_export__ = i; exports.ZP = d;


/***/ }),

/***/ 60374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ shallow; }
/* harmony export */ });
function shallow(objA, objB) {
  if (Object.is(objA, objB)) {
    return true;
  }
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  const keysA = Object.keys(objA);
  if (keysA.length !== Object.keys(objB).length) {
    return false;
  }
  for (let i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}




/***/ })

}]);